<div class="bodyValue">
    <div class="row" style="background-color:#e9ecef;margin: 0 5px;padding: 15px 0;">
        <div class="col-md-6" style="text-transform: capitalize;">
            Home
        </div>
    </div>

    <div style="margin: 10px 5px 0;">
        <div class="row mb-2">

            <!-- User Management -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('User-Management')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">User Management</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('User-Management')">Click Here</a>
                    </div>
                </div>
            </aside>

            <!-- Diary Dak  -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('DakDairy')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Diary Dak</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('DakDairy')">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Executive Committee')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Meetings</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('ecAgenda')">Click Here</a>
                    </div>
                </div>
            </aside>

            <!-- Legal Module Start -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Legal')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Legal</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('Legal')">Click Here</a>
                    </div>
                </div>
            </aside>   
            <!-- Legal Module End -->

            <!-- Added by gokul student card Grievance  -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Grievance')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Complaints/Grievance</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('Grievance')">Click Here</a>
                    </div>
                </div>
            </aside>

              <!-- Added by Radha card UIDR  -->
              <aside class="col-sm-4 col-md-4"  *ngIf="moduleName.includes('UIDR')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">UIDR</h5>
                        <a class="btn btn-primary btn-sm" (click)="UIDRClick()">Click Here</a>
                    </div>
                </div>
            </aside>

            <!-- Inspection added by gokul-->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Inspection')&& roleName!='Inspector'">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Inspection</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('Inspection')">Click Here</a>
                    </div>
                </div>
            </aside>

            <!-- Added by gokul for Eligibility Certificate  -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Eligibility')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Eligibility Certificate</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('Eligibility')">Click Here</a>
                    </div>
                </div>
            </aside> 

            <!-- FQSRModule Dashboard by Kannan -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('FQSR')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Foreign Qualification Screening and Registration (FQSR)</h5>
                        <!-- <a routerLink="../../../main/internal/fqsr/secDashboard" routerLinkActive="router-link-active" class="btn btn-primary btn-sm">Click Here</a> -->
                        <a class="btn btn-primary btn-sm" (click)="redirectToFQSRUserPage()">Click Here</a>
                    </div>
                </div>
            </aside>

            <!-- PTR By Sugand -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('PTR')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Permission for Temporary Registration (PTR)</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('PTR')">Click Here</a>
                    </div>
                </div>
            </aside>
           
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('DMS')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Document Management System</h5>
                        <a class="btn btn-primary btn-sm" (click)="dms()">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('NOC')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">NOC</h5>
                        <a class="btn btn-primary btn-sm" (click)="NOC()">Click Here</a>
                    </div>
                </div>
            </aside>
            
            <!-- College Module -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('StudentAdmission&CourseCompletion')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Student Admission</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('StudentAdmission')">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Course Completion')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Student Course Progression</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('courseCompletion')">Click Here</a>
                    </div>
                </div>
            </aside>       
         
            <!-- Anti-Ragging By Riyaz -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('AntiRagging')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Anti-Ragging<span style="font-size: 15px;">(Under provision 12.1 & 12.2)</span></h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('AntiRagging')">Click Here</a>
                    </div>
                </div>
            </aside>
                   
            <!-- Anti-Ragging Orientation Program Added By Ishvarya -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('AntiRagging') && roleName === 'College Principal'">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Anti-Ragging Orientation Program</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('antiRaggingOrientationProgram')">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('SAR') && (roleName === 'College Principal' || roleName === 'College Representative')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Self Assessment</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('SA')">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('SAR')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Self Assessment Report</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('SAR')">Click Here</a>
                    </div>
                </div>
            </aside>

           <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Audit Log')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Audit Log</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('Audit Log')">Click Here</a>
                    </div>
                </div>
            </aside>   

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('MDM')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">MDM</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('MDM')">Click Here</a>
                    </div>
                </div>
            </aside>       
            
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('MIS')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">MIS</h5>
                        <a class="btn btn-primary btn-sm" (click)="MIS()">Click Here</a>
                    </div>
                </div>
            </aside>    

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('IT HelpDesk')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">HelpDesk</h5>
                        <a class="btn btn-primary btn-sm" (click)="ITHelpDesk()">Click Here</a>
                    </div>
                </div>
            </aside>     
            
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Profile')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Profile</h5>
                        <a class="btn btn-primary btn-sm" (click)="Profile()">Click Here</a>
                    </div>
                </div>
            </aside>
          
            <aside class="col-sm-4 col-md-4" *ngIf="roleName==='Advocate'">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Advocate Dashboard</h5>
                        <a class="btn btn-primary btn-sm" (click)="Advocate()">Click Here</a>
                    </div>
                </div>
            </aside>

            <!-- New College By Riyaz -->
            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('New College')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">New College</h5>
                        <a class="btn btn-primary btn-sm" (click)="NewCollege()">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('ERP')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">ERP</h5>
                        <a class="btn btn-primary btn-sm" (click)="ERP()">Click Here</a>
                    </div>
                </div>
            </aside>        

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('HRMS')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">HRMS</h5>
                        <a class="btn btn-primary btn-sm" (click)="HRMS()">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Accounts')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Accounts</h5>
                        <a class="btn btn-primary btn-sm" (click)="Accounts()">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('SLA')">
                <div class="card-banner overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">SLA</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('SLA')">Click Here</a>
                    </div>
                </div>
            </aside>

            <aside class="col-sm-4 col-md-4" *ngIf="moduleName.includes('Fee Collection')">
                <div class="card-banner  overlay-grad" style="width: 100%;">
                    <div class="overlay m-2 w-100 text-center">
                        <h5 class="card-title">Fee Collection</h5>
                        <a class="btn btn-primary btn-sm" (click)="sendUser('Fee Collection')">Click Here</a>
                    </div>
                </div>
            </aside>

        </div>
    </div>
</div>